import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/global.css'

// 1. 引入你需要的组件
import {
    Tabbar,
    TabbarItem,
    Button,
    Notify,
    Tab,
    Tabs,
    Col,
    Row,
    Icon,
    Popover,
    Image as VanImage,
    ActionSheet,
    Divider,
    Toast,
    DatePicker,
    Popup,
    Dialog,
    Sticky,
    Pagination,
    Empty, showNotify,
    NoticeBar,
    Switch,
    Field
} from 'vant';
// 2. 引入组件样式
import 'vant/lib/index.css';

const app = createApp(App)

// 假设你把用户登录信息存在 localStorage 或 Vuex
function isLoggedIn() {
    return !!localStorage.getItem('token')
}

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!isLoggedIn()) {
            // Toast.fail('请先登录')
            // 阻止导航
            // return next(false)
            showNotify({ type: 'warning', message: '请先登录！' });
            return next({name: 'login'})
            // 或者跳到登录页：next({ name: 'login' })
        }
    }
    next()
})

app.use(router).mount('#app')

// 3. 注册你需要的组件
app.use(Empty);
app.use(Pagination);
app.use(Sticky);
app.use(Dialog);
app.use(Popup);
app.use(DatePicker);
app.use(Toast);
app.use(Divider);
app.use(ActionSheet);
app.use(VanImage);
app.use(Popover);
app.use(Icon);
app.use(Col);
app.use(Row);
app.use(Tab);
app.use(Tabs);
app.use(Notify);
app.use(Button);
app.use(Tabbar);
app.use(TabbarItem);
app.use(NoticeBar);
app.use(Switch);
app.use(Field);
